module.exports = __webpack_public_path__ + "static/media/image.ac6fe2c9.png";